import React, { Component } from "react";
import styled from "styled-components";

const Outer = styled.div`
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;
  overflow: hidden;
  border-radius: 8px;
`;

export default class Responsive extends Component {
    dummyData = [{
        previewImg: "./img/items/1.jpg",
        name: "Keon",
        task: "Pilot",
        introduction: "hardcore LUNAtic and Crypto and Web3 maxi based in Seoul. Also producing kick-ass Gochujang based hot sauce IG: @janghotsauce",
    },
    {
        previewImg: "./img/items/2.jpg",
        name: "Patrick",
        task: "Co-Pilot",
        introduction: "Currently working as a engineer/designer in crypto. Planning to build various projects on Terra. Always imagining new things with the endless possibilities of blockchain in mind.",
    },
    {
        previewImg: "./img/items/3.jpg",
        name: "Daniel",
        task: "Co-Pilot",
        introduction: "Software enginner and NFT enthusiast based in Seoul. Currently working on a marketplace to sell Instagram posts and youtube videos in NFTs.",
    },
    {
        previewImg: "./img/items/4.jpg",
        name: "Woong",
        task: "Marketer/Community manager",
        introduction: "Fascinated by NFTs & Interested in the social ripple that NFTs will bring. Big fan of the Terra Ecosystem. Excited to spread Santa's love.",
    }]

    constructor(props) {
    super(props);
    this.state = {
        nfts: this.dummyData,
    height: 0
    };
    this.onImgLoad = this.onImgLoad.bind(this);
    }

    onImgLoad({target:img}) {
        let currentHeight = this.state.height;
        if(currentHeight < img.offsetHeight) {
            this.setState({
                height: img.offsetHeight
            })
        }
    }

 render() {
  return (
    <div className='row'>
        {this.state.nfts.map( (nft, index) => (
            <div key={index} className="d-item col-lg-3 col-md-6 col-sm-6 col-xs-12">
                <div className="nft__item">
                    <div className="nft__item_wrap" style={{height: `${this.state.height}px`}}>
                      <Outer>
                        <span >
                            <img onLoad={this.onImgLoad} src={nft.previewImg} className="lazy nft__item_preview" alt=""/>
                        </span>
                      </Outer>
                    </div>
                    <div className="nft__item_info">
                        <span>
                            <h4>{nft.name}</h4>
                        </span>
                        <div className="nft__item_price">
                            {nft.task}<br/><span>{nft.introduction}</span>
                        </div>
                       
                    </div> 
                </div>
            </div>  
        ))}
        
    </div>              
    );
}
}